import { render } from "./AutomaticReportList.vue?vue&type=template&id=730e7bf4&scoped=true"
import script from "./AutomaticReportList.vue?vue&type=script&lang=js"
export * from "./AutomaticReportList.vue?vue&type=script&lang=js"

import "./AutomaticReportList.vue?vue&type=style&index=0&id=730e7bf4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730e7bf4"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QInput,QIcon,QBtn,QTd});
